export default {"src":"/_next/static/media/taskrabbit-logo.b4d46fdd.svg","height":101,"width":610,"blurWidth":0,"blurHeight":0};